// React
import Cookies from 'js-cookie';

const COOKIE_KEY = 'lang';

export function saveLanguageToCookie(language) {
  Cookies.set(COOKIE_KEY, language, { expires: 365, path: '/' });
}

export function getLanguageFromCookie() {
  return Cookies.get(COOKIE_KEY);
}
